import React from "react";
import "../../all css/userinfodialogbox.css";
const user_img = require("../../../assets/aboutexplore/leader1.png");
const social_img1 = require("../../../assets/fb.png");
const social_img2 = require("../../../assets/link.png");
const social_img3 = require("../../../assets/twitter.png");
const leader_img2 = require("../../../assets/aboutexplore/counsil1.png");

function UserInfo(props) {
  return (
    <div className="user_info_main_container">
      <div className="user_info_under_main_container">
        <div className="user_flex_container">
          <div className="user_img_container">
            <img
              src={props.userDetails.leaderImg}
              alt="user_img"
              className="user_img"
            />
          </div>
          <div className="user_content_container">
            <div>
              <p className="user_title">{props.userDetails.leaderName}</p>
              <p className="user_subtitle">{props.userDetails.leaderSubname}</p>
              <p className="user_extra_content">
                {props.userDetails.personInfo}
              </p>
            </div>

            <div className="user_social_link">
              <p>Follow Us On :</p>
              <div className="social_img_container">
              
                <a href={props.userDetails.linkUserLink}>
                  <img src={social_img2} alt="linkdln" className="social_img" />
                </a>
                <a href={props.userDetails.twitterUserLink}>
                  <img src={social_img3} alt="twitter" className="social_img" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserInfo;
